import {createActions} from '../../../baseClasses/ActionFactory';
const {types: generalTypes, actions: generalActions} = createActions({store: 'GOODS'});
const allActions = {...generalActions};
const allTypes = {...generalTypes};
export {allTypes as types, allActions as actions};
